"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useAddButtonStyle = ({ disabled }) => {
    const theme = (0, material_1.useTheme)();
    const container = {
        background: disabled ? 'transparent' : theme.qlub.palette.iris_light.main,
        width: '24px',
        height: '24px',
        borderRadius: '100px',
        '&.Mui-disabled': {
            background: disabled ? 'transparent' : theme.qlub.palette.dim.main,
        },
        '&:hover': {
            cursor: 'pointer',
        },
    };
    const icon = {
        fontSize: '24px',
        color: disabled ? theme.qlub.palette.onSurfaceColors.disabled : `${theme.qlub.palette.iris.main} !important`,
    };
    return {
        container,
        icon,
    };
};
exports.default = useAddButtonStyle;
